<!--
    描述：菜单
    日期：2021/04/27
    作者：zwh
-->
<template>
    <div class="h100">
        <div class="w-page-main">
            <div class="w-page-header superiors-search-area">
                <div class="left-text overflow-hidden">
                    <span><b>菜单列表</b></span>
                </div>
                <div class="btnGroups">
                    <el-button type="success" size="small" icon="el-icon-check"
                               v-if="roleBtns.includes('group_role_menu_save')"
                               @click="saveClick()">保存
                    </el-button>
                </div>
            </div>
            <div class="w-page-container pdb10">
                <div class="w-table-layout">
                    <div class="w-table-content" ref="content" style=" overflow-y: auto; border:1px solid #eee">
                        <el-tree ref="tree"
                                 :height="treeObj.tableH"
                                 :data="treeObj.data"
                                 :props="defaultProps"
                                 :expand-on-click-node="false"
                                 :highlight-current="true"
                                 default-expand-all
                                 show-checkbox
                                 :check-strictly="true"
                                 node-key="id"
                                 :default-checked-keys="treeDefaultCheckedKey"
                                 @node-click="nodeClick"
                        ></el-tree>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import {selectTree} from 'api/system/menu.js'
    import {saveOrUpdateRoleMenu, getCheckedMenu, getLimitMenu} from 'api/system/sysGroupRoleMenu.js'

    export default {
        name: '',
        components: {},
        data() {
            return {
                //树默认选中信息
                treeDefaultCheckedKey: [],

                treeObj: {
                    loading: false,
                    tableH: 200,
                    data: [],

                    oriData: [],
                    dataByRoleData: [],
                },
                defaultProps: {
                    children: 'children',
                    label: 'sname'
                },

                groupId: '',
                roleId: '',
                roleType: '',
            }
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.treeObj.tableH = this.$refs.content.offsetHeight;
                }, 100)
            })
        },
        computed: {
            ...mapState('app', {clientSize: state => state.clientSize}),
            ...mapState('menu', {
                roleBtns: state => state.roleBtns
            })
        },
        watch: {
            clientSize(val) {
                this.treeObj.tableH = this.$refs.content.offsetHeight;
            }
        },
        created() {
            //获取菜单信息
            this.getMenuTreeTableData();
        },
        methods: {
            init(obj) {
                //数据初始化
                this.treeDefaultCheckedKey = []
                this.treeObj.data = this.treeObj.oriData.concat()

                this.groupId = obj.groupId  //组id
                this.roleId = obj.roleId    //角色id
                this.roleType = obj.roleType    //角色类型
                if (obj.roleId == '') return

                //获取权限菜单数据
                this.getCheckedMenu()
                //获取限定菜单数据
                this.getLimitMenu()
            },

            // 根据角色ID 返回能选择的 和 已选择的菜单
        getRoleMenuRange(obj) {
            this.roleId = obj.id;
            this.treeDefaultCheckedKey = [];

            getRoleMenuRange({
                roleId: obj.id,
                isSys: "1",
            }).then((res) => {
                // 能选数组
                this.getLimitMenus(res.data.limitMenuIds, obj.limitId)

                // 赋值选中菜单
                this.treeDefaultCheckedKey = res.data.roleMenuIds;

                if (this.treeDefaultCheckedKey.length > 0) {
                    let _item = this.$utils.findTree(this.menusTreeData.tableData, x => x.id === this.treeDefaultCheckedKey[0])
                    setTimeout(() => {
                        _item ? this.nodeClick(_item.item) : "";
                        this.$refs.menusTree.setCurrentKey(this.treeDefaultCheckedKey[0]);
                    }, 200);
                }
            });
        },

            //获取菜单信息
            getMenuTreeTableData() {
                let that = this
                selectTree({isSys: 1}).then(res => {
                    if (res.operationCode == 1) {
                        that.treeObj.oriData = res.data;
                        that.treeObj.data = that.treeObj.oriData.concat()
                    }
                });
            },
            //获取默认选中菜单信息
            getCheckedMenu() {
                let that = this
                let param = {
                    groupId: this.groupId,
                    roleId: that.roleId,
                }
                getCheckedMenu(param).then(res => {
                    if (res.operationCode == 1) {
                        this.treeDefaultCheckedKey = res.data
                        that.treeObj.data = that.treeObj.data.concat()
                    }
                })
            },
            //获取范围内菜单信息
            getLimitMenu() {
                let that = this
                //预设角色
                //if(that.roleType=='1007001') {
                let data = that.treeObj.data.concat()
                data = that.$utils.toTreeArray(data)
                //设置所有菜单不可用
/*                data = data.map(v => {
                    return {...v, disabled: true}
                })*/
                data = that.$utils.toArrayTree(data)
                that.treeObj.data = data.concat()
                //return
                //}
                if (that.roleType == '1007001') return
                let param = {}
                getLimitMenu(param).then(res => {
                    if (res.operationCode == 1) {
                        //范围内菜单id list
                        let useMenuIdList = res.data
                        let data = that.$utils.toTreeArray(that.treeObj.data)
/*                        let userArr = data.filter(menu => useMenuIdList.includes(menu.id)).map(v => {
                            return {...v, disabled: false}
                        })*/
                        //设置范围内菜单信息可用
/*                        data.forEach(item => {
                            let obj = userArr.find(v => item.id == v.id)
                            if (obj) item.disabled = false
                        })*/
                        that.treeObj.data = that.$utils.toArrayTree(data).concat()
                    }
                })
            },
            //保存
            saveClick() {
                let that = this
                if (that.roleId == '') {
                    that.$message({message: '请选择角色信息', type: 'warning'});
                    return;
                }

                let menuIdsSelection = [];
                let checkSelection = this.$refs.tree.getCheckedKeys().concat()
                let param = {
                    groupId: this.groupId,
                    roleId: that.roleId,
                    menuIdsSelection: checkSelection
                }
                saveOrUpdateRoleMenu(param).then(res => {
                    if (res.operationCode == 1) {
                        that.$message({message: '保存成功', type: 'success'});
                    }
                });
            },
            //节点点击
            nodeClick(obj) {
                this.$emit('row-click', obj)
            },
        }
    }
</script>
<style lang="less">

</style>